import { Event } from "@/events/Event";
class MEvent {
    constructor() {
        this.sendmessage = new Event("sendmessage");
        this.newbackmessage = new Event("newbackgroundmessage");
        this.newmember = new Event("newmember");
        this.newoffer = new Event("offer");
        this.newanswer = new Event("answer");
        this.mediaobject = new Event("adduipeer");
        this.icecan = new Event("icecan");
        this.shutdown = new Event("shutdown");
        this.peerdiconnected = new Event("peerdisconnected");
        this.audiomuteunmute = new Event("audiomuteunmute");
        this.sharingscreen = new Event("sharingscreen");
        this.speaking = new Event("speaking");
        this.localsharingstopped = new Event("sharingstopped");
        this.videofacingcamera = new Event("videofacingcamera");
        this.videoenvcamera = new Event("videoenvcamera");
    }
    addSubcriberForSharingStopped(sub) {
        this.localsharingstopped.subscribe(sub);
    }
    removeSubscriberForSharingStopped(sub) {
        this.localsharingstopped.unsubscribe(sub);
    }
    publishSharingStopped() {
        this.localsharingstopped.publish();
    }
    addSubcriberForSpeaking(sub) {
        this.speaking.subscribe(sub);
    }
    removeSubscriberForSpeaking(sub) {
        this.speaking.unsubscribe(sub);
    }
    publishSpeaking(message) {
        this.speaking.publish(message);
    }
    addSubcriberForNewBackgroundMessage(sub) {
        this.newbackmessage.subscribe(sub);
    }
    removeSubscriberForNewBackgroundMessage(sub) {
        this.newbackmessage.unsubscribe(sub);
    }
    publishNewBackgroundMessage(message) {
        this.newbackmessage.publish(message);
    }
    addSubcriberForSharingScreen(sub) {
        this.sharingscreen.subscribe(sub);
    }
    removeSubscriberForVideoFacingCamera(sub) {
        this.videofacingcamera.unsubscribe(sub);
    }
    publishVideoFacingCamera(peerid) {
        this.videofacingcamera.publish(peerid);
    }
    addSubscriberForVideoFacingCamera(sub) {
        this.videofacingcamera.subscribe(sub);
    }
    removeSubscriberForVideoEnvCamera(sub) {
        this.videoenvcamera.unsubscribe(sub);
    }
    publishVideoEnvCamera(peerid) {
        this.videoenvcamera.publish(peerid);
    }
    addSubscriberForVideoEnvCamera(sub) {
        this.videoenvcamera.subscribe(sub);
    }
    removeSubscriberForSharingScreen(sub) {
        this.sharingscreen.unsubscribe(sub);
    }
    publishSharingScreen(message) {
        this.sharingscreen.publish(message);
    }
    addSubcriberForAudioMuteUnmute(sub) {
        this.audiomuteunmute.subscribe(sub);
    }
    removeSubscriberForAudioMuteUnmute(sub) {
        this.audiomuteunmute.unsubscribe(sub);
    }
    publishAudioMuteUnmute(message) {
        this.audiomuteunmute.publish(message);
    }
    addSubcriberForPeerDisconnected(sub) {
        this.peerdiconnected.subscribe(sub);
    }
    removeSubscriberForPeerDisconnected(sub) {
        this.peerdiconnected.unsubscribe(sub);
    }
    publishPeerDisconnected(message) {
        this.peerdiconnected.publish(message);
    }
    addSubcriberForMediaObject(sub) {
        this.mediaobject.subscribe(sub);
    }
    removeSubscriberForMediaObject(sub) {
        this.mediaobject.unsubscribe(sub);
    }
    publishMediaObject(message) {
        this.mediaobject.publish(message);
    }
    addSubcriberForShutdown(sub) {
        this.shutdown.subscribe(sub);
    }
    removeSubscriberForShutdown(sub) {
        this.shutdown.unsubscribe(sub);
    }
    publishShutdown() {
        this.shutdown.publish();
    }
    addSubcriberForNewICECandidater(sub) {
        this.icecan.subscribe(sub);
    }
    removeSubscriberForNewICECandidate(sub) {
        this.icecan.unsubscribe(sub);
    }
    publishNewICECandidate(message) {
        this.icecan.publish(message);
    }
    addSubcriberForNewAnswer(sub) {
        this.newanswer.subscribe(sub);
    }
    removeSubscriberForNewAnswer(sub) {
        this.newanswer.unsubscribe(sub);
    }
    publishNewAnswer(message) {
        this.newanswer.publish(message);
    }
    addSubcriberForNewOffer(sub) {
        this.newoffer.subscribe(sub);
    }
    removeSubscriberForNewOffer(sub) {
        this.newoffer.unsubscribe(sub);
    }
    publishNewOffer(message) {
        this.newoffer.publish(message);
    }
    addSubcriberForSendMessage(sub) {
        this.sendmessage.subscribe(sub);
    }
    removeSubscriberForSendMessage(sub) {
        this.sendmessage.unsubscribe(sub);
    }
    publishForSendMessage(message) {
        this.sendmessage.publish(message);
    }
    addSubcriberForNewMember(sub) {
        this.newmember.subscribe(sub);
    }
    removeSubscriberForNewMember(sub) {
        this.newmember.unsubscribe(sub);
    }
    publishForNewMember(message) {
        this.newmember.publish(message);
    }
}
export const MediaEvent = new MEvent;
